module.exports = __webpack_public_path__ + "static/media/steak.5cf6eed8.svg";